// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1zcgs","description":"PatientConsentPreview_description__hygAt"};